var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-wrap"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("抱歉！页面无法访问……点击下方按钮返回首页")]),_vm._v(" "),_c('router-link',{attrs:{"to":"./"}},[_c('img',{attrs:{"src":require("../../static/img/ibroadcast/back2home3.png"),"width":"390"}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef380d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notfound.vue
// module id = null
// module chunks = 